import { Col, Row } from "react-bootstrap";
import React from "react";
import {FormProvider, useForm, useFormContext} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import {NFLookupCompany} from "src/components/Shared/NewForms/NFLookupCompany";
import {NFTextInput} from "src/components/Shared/NewForms/NFTextInput";
import {NFDateInput} from "src/components/Shared/NewForms/NFDateInput";
import {NFLookupWarehouse} from "src/components/Shared/NewForms/NFLookupWarehouse";
import {NFLookupVendor} from "src/components/Shared/NewForms/NFLookupVendor";
import {NFLookupContract} from "src/components/Shared/NewForms/NFLookupContract";
import {NFLookupDivision} from "src/components/Shared/NewForms/NFLookupDivision";
import {NFLookupInput} from "src/components/Shared/NewForms/NFLookupInput";
import {EnumHelper} from "src/helpers/EnumHelper";

export const PurchaseOrderDetailMain = () => {
    const { t } = useTranslation();
    const {watch, ...methods } = useFormContext();

    return (
        <>
            <Row>
                <Col sm={3}>
                    <NFTextInput
                        title={t("Document#")}
                        disabled
                        fieldName="documentNumber"
                    />
                </Col>
                <Col sm={3}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName="documentDate"
                        required={true}
                    />
                </Col>
                <Col sm={3}>
                    <NFDateInput
                        title={t("ApprovalDate")}
                        fieldName="approvalDate"
                    />
                </Col>
                <Col sm={3}>
                    <NFLookupCurrency
                        fieldName="currencyId"
                        title={t("Currency")}
                        required
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCompany
                        fieldName="companyId"
                        title={t("Company")}
                        required
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupWarehouse
                        fieldName="warehouseId"
                        title={t("Warehouse")}
                        companyId={watch("companyId")}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupVendor
                        title={t("Vendor")}
                        fieldName="vendorId"
                        required
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupContract
                        // vendorCustomerId={getValues("vendorId")}
                        fieldName="contractId"
                        title={t("Contract")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupDivision
                        fieldName="divisionId"
                        title={t("Division")}
                        required
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupInput
                        title={t("Status")}
                        fieldName="status"
                        items={EnumHelper.GetPurchaseTypeArrayForLookup()}
                    />
                </Col>
            </Row>
        </>
    );
};
